import { Injectable, EventEmitter } from '@angular/core';

@Injectable()
export class LoadingService {
	loadingEvent: EventEmitter<any> = new EventEmitter();
	genericLoadingEvent: EventEmitter<any> = new EventEmitter();
}
